import { LinearProgress } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ItemPastorDevotion from '../../../components/fragments/ItemPastorDevotion';
import ListEmpty from '../../../components/fragments/ListEmpty';
import { rtGetListData } from '../../../store/slices/listSlice';

export default function Devotions() {
    const dispatch = useDispatch();
    const state = useSelector((st) => st);
    const { list2, auth } = state;
    const { user } = auth;
    const { busy } = list2;

    const REFERENCE = `${user?.username}devotions`;

    const refetch = useCallback(() => {
        dispatch(rtGetListData(`op/devotions`, REFERENCE));
    }, [REFERENCE, dispatch]);

    useEffect(() => {
        refetch();
    }, [refetch]);

    return (
        <>
            {busy[REFERENCE] && <LinearProgress />}
            {list2[REFERENCE]?.map((devotion) => (
                <ItemPastorDevotion key={devotion?.id} devotion={devotion} />
            ))}
            {list2[REFERENCE]?.length < 1 && (
                <ListEmpty title="No devotions yet" />
            )}
        </>
    );
}
